<!-- Start Page Banner Area -->
<div class="page-banner-area ptb-100" *ngIf="data" style="background-image: url({{data.attributes.pageBannerBgImage.data.attributes.url}});">
    <div class="container">
      <div class="page-banner-content">
        <h2>{{data.attributes.pageBannerTitle}}</h2>
        <ul>
          <li>
            <a routerLink="/">Accueil</a>
          </li>
          <li>{{data.attributes.pageBannerTitle}}</li>
        </ul>
      </div>
    </div>
  </div>
  
  <!-- Sign Up -->
  <div class="sign-up-area ptb-100 mt-5">
    <div class="container">
      <div class="sign-up-form">
        <h2>Créez votre compte</h2>
        <p>Créez votre compte gratuitement et bénéficiez de l'ensemble de nos services.</p>
        <form [formGroup]="regForm" (ngSubmit)="onRegister()">
          <div class="form-group">
            <label>Nom</label>
            <input class="form-control" type="text" name="name" placeholder="Name" formControlName="name">
            <div *ngIf="regForm.get('name')?.invalid && regForm.get('name')?.touched" class="text-danger small mt-1">
              Le nom est requis.
            </div>
          </div>
          <div class="form-group">
            <label>Adresse Email</label>
            <input class="form-control" type="email" name="email" placeholder="Email address" formControlName="email">
            <div *ngIf="regForm.get('email')?.invalid && regForm.get('email')?.touched" class="text-danger small mt-1">
              Une adresse email valide est requise.
            </div>
          </div>
          <div class="form-group">
            <label>Mot de passe</label>
            <input class="form-control" type="password" name="password" placeholder="Password" formControlName="password">
            <div *ngIf="regForm.get('password')?.errors?.['minlength'] && regForm.get('password')?.touched" class="text-danger small mt-1">
              Le mot de passe doit contenir au moins 6 caractères.
            </div>
            <div *ngIf="regForm.get('password')?.errors?.['passwordWeak'] && regForm.get('password')?.touched" class="text-danger small mt-1">
              Le mot de passe doit contenir au moins une majuscule et un caractère spécial.
            </div>
          </div>
          <div class="form-group">
            <label>Confirmez votre mot de passe</label>
            <input class="form-control" type="password" placeholder="Confirm Password" name="repeat-password" formControlName="repeat_password">
            <div *ngIf="regForm.get('repeat_password')?.invalid && regForm.get('repeat_password')?.touched" class="text-danger small mt-1">
              La confirmation est requise (minimum 6 caractères).
            </div>
            <div *ngIf="regForm.hasError('passwordsMismatch') && regForm.get('repeat_password')?.touched" class="text-danger small mt-1">
              Les mots de passe ne correspondent pas.
            </div>
          </div>
          <p class="description">Le mot de passe doit comporter au moins six caractères. Pour le renforcer, utilisez des lettres majuscules et minuscules, des chiffres et des symboles tels que ! " ? $ % ^ & )</p>
          
          <!-- Bouton avec état de chargement -->
          <button type="submit" class="default-btn" [disabled]="isSubmitting">
            <span *ngIf="!isSubmitting">Créer le compte</span>
            <span *ngIf="isSubmitting">
              <i class="fas fa-spinner fa-spin"></i> Création en cours...
            </span>
          </button>
          
          <div class="account-text">
            <span class="text-black">Vous avez déjà un compte ? <a routerLink="/sign-in">Connectez-vous</a></span>
          </div>
        </form>
      </div>
    </div>
  </div>
  
  <!-- ✨ POPUP DE SUCCÈS MODERNE -->
  <div class="success-modal-overlay" *ngIf="showSuccessModal" (click)="closeModal()">
    <div class="success-modal-content" 
         (click)="$event.stopPropagation()"
         (mouseenter)="pauseCountdown()"
         (mouseleave)="resumeCountdown()">
      <!-- Animation de succès -->
      <div class="success-icon-container">
        <div class="success-checkmark">
          <div class="check-icon">
            <span class="icon-line line-tip"></span>
            <span class="icon-line line-long"></span>
            <div class="icon-circle"></div>
            <div class="icon-fix"></div>
          </div>
        </div>
      </div>
      
      <!-- Contenu du popup -->
      <div class="modal-body">
        <h2>🎉 Compte créé avec succès !</h2>
        <p class="main-message">
          Félicitations ! Votre compte <strong>AfroTech Hub</strong> a été créé avec succès.
        </p>
        
        <!-- Carte email avec animation -->
        <div class="email-card" (mouseenter)="pauseCountdown()" (mouseleave)="resumeCountdown()">
          <div class="email-icon">
            📧
          </div>
          <div class="email-content">
            <h3>Vérifiez votre boîte mail</h3>
            <p>Un email de confirmation a été envoyé à :</p>
            <div class="email-address">{{ userEmail }}</div>
            <div class="email-tips">
              💡 <strong>Conseils :</strong> Vérifiez aussi vos <em>spams/courriers indésirables</em>
            </div>
          </div>
        </div>
        
        <!-- Actions -->
        <div class="modal-actions">
          <button class="btn-primary" 
                  (click)="goToSignIn()"
                  (mouseenter)="pauseCountdown()">
            <i class="fas fa-sign-in-alt"></i>
            Aller à la connexion
          </button>
          <button class="btn-secondary" 
                  (click)="goToHome()"
                  (mouseenter)="pauseCountdown()">
            <i class="fas fa-home"></i>
            Aller à l'accueil
          </button>
        </div>
        
        <!-- Compte à rebours avec état -->
        <div class="countdown" [class.paused]="countdownPaused">
          <div *ngIf="!countdownPaused">
            Redirection automatique dans <span class="countdown-number">{{ countdown }}</span> secondes...
          </div>
          <div *ngIf="countdownPaused" class="countdown-paused">
            ⏸️ Compte à rebours en pause - Survolez ailleurs pour reprendre
          </div>
        </div>
      </div>
      
      <!-- Bouton fermer -->
      <button class="modal-close" 
              (click)="closeModal()"
              (mouseenter)="pauseCountdown()">
        <i class="fas fa-times"></i>
      </button>
    </div>
  </div>